import { Post } from "./request";
import { ClearCache } from "./recordService";

export function AddContactToMarketingList(
  dispatch,
  marketingListId,
  contactId
) {
  ClearCache("listmember");
  ClearCache("list");
  return Post(
    dispatch,
    "AddMarketingListMember",
    "Contact added to marketing list",
    { Id: marketingListId, Attributes: { contactid: contactId } }
  );
}

export function RemoveContactFromMarketingList(
  dispatch,
  marketingListId,
  contactId
) {
  ClearCache("listmember");
  ClearCache("list");
  return Post(
    dispatch,
    "RemoveMarketingListMember",
    "Contact removed from marketing list",
    { Id: marketingListId, Attributes: { contactid: contactId } }
  );
}
